import { CardTypeMembershipFeeApiModel } from './card-type-membership.api.model';

export class CardTypeMembershipExtensionFeeApiModel extends CardTypeMembershipFeeApiModel {}
